export enum WebhookStatus {

    ACTIVE      = 1,

    // Set by the server after 3 consecutive failed deliveries. Nothing is sent
    // until the webhook is reactivated, and nothing notifies the owner — the
    // webhooks list is the only place this state is visible.
    SUSPENDED   = 2,
}

// A delivery is a failure on any non-2xx response or a timeout over 5s.
export const WEBHOOK_MAX_ERRORS = 3

// Settings -> Integrations -> Webhooks. Also the menu item's url.
export const WEBHOOKS_SETTINGS_URL = 'settings/webhooks'
